<div>
    <mat-spinner></mat-spinner>
    <h2 class="text">{{text.PROGRESSING}}</h2>
</div>